// eslint-disable-next-line import/no-unresolved
import Nullstack from './{{NULLSTACK_ENVIRONMENT_NAME}}'

export default Nullstack
